import { useAppStore } from "../../../../appStore";

export const generateNavigationString = (
  userFiltersSMTP: any,
  groupIDSMTP: number | null,
  type: string
) => {
  // Format date to MMM-DD-YYYY format
  const formatDateForNavigation = (date: Date) => {
    if (!date) return "";
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = months[date.getMonth()];
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  };

  // Format time to HHMM format
  const formatTimeForNavigation = (time: Date | null) => {
    if (!time) return "";
    const hours = time.getHours().toString().padStart(2, "0");
    const minutes = time.getMinutes().toString().padStart(2, "0");
    return `${hours}${minutes}`;
  };

  const queryParams: string[] = [];

  const { userPermissions } = useAppStore.getState();

  const userInfo = JSON.parse(localStorage.userInfo);

  // Add group if it exists
  if (groupIDSMTP) {
    queryParams.push(`group=${groupIDSMTP}`);
  }

  if (!groupIDSMTP && userPermissions.smtp) {
    if (userInfo?.group?.id) {
      queryParams.push(`group=${userInfo?.group?.id}`);
    }
  }

  // Add site if it exists
  if (userFiltersSMTP.site_ids?.[0]) {
    queryParams.push(`site=${userFiltersSMTP.site_ids[0]}`);
  }

  // Add camera if it exists
  if (userFiltersSMTP.camera_ids?.[0]) {
    queryParams.push(`camera=${userFiltersSMTP.camera_ids[0]}`);
  }

  // Add start_date if it exists
  const startDate = formatDateForNavigation(userFiltersSMTP.start_date);
  if (startDate) {
    queryParams.push(`start_date=${startDate}`);
  }

  // Add end_date if it exists
  const endDate = formatDateForNavigation(userFiltersSMTP.end_date);
  if (endDate) {
    queryParams.push(`end_date=${endDate}`);
  }

  if (type === "alerts") {
    queryParams.push(`filter_type=All`);
    queryParams.push(`detection_type=All`);
  }

  // Add start_time if it exists
  const startTime = formatTimeForNavigation(userFiltersSMTP.start_time);
  if (startTime) {
    queryParams.push(`start_time=${startTime}`);
  }

  // Add end_time if it exists
  const endTime = formatTimeForNavigation(userFiltersSMTP.end_time);
  if (endTime) {
    queryParams.push(`end_time=${endTime}`);
  }

  return queryParams.join("&");
};
